export default "__VITE_ASSET__B8l5L9vz__"